import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createUser } from "api/auth";
import { CreateUserData } from "types/user";
import getFirebaseIdToken from "utils/getFirebaseIdToken";
import useShowSnackBar from "hooks/snackBar/useShowSnackBar";
import { useTranslation } from "react-i18next";

const useCreateUser = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const showSnackBar = useShowSnackBar();

  return useMutation<void, Error, CreateUserData>(
    ["create-user"],
    async (payload) => {
      const token = await getFirebaseIdToken();
      if (token) {
        return createUser(token, payload);
      }

      // if (payload.email == null) return Promise.reject(new Error("Invalid email"));
      return Promise.reject(new Error("Invalid Firebase ID Token"));
    },
    {
      onSuccess: () => {
        return queryClient.invalidateQueries({ queryKey: ["user"] });
      },
      onError: (error) => {
        showSnackBar({
          title: t("notification.commonError.title"),
          text: error.message,
          variant: "error",
        });
      },
    },
  );
};

export default useCreateUser;
